module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Steel + White Open.7a730e6d.png";